module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-46-min.7051aa57.jpg";